const NumberFrame = ({ label, value }: { label: string; value: string }) => (
	<div
		style={{
			backgroundColor: '#DEE4F1',
			borderRadius: '8px',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			alignItems: 'center',
			padding: '8px 16px',
			width: '300px',
			height: '160px',
			gap: '16px',
		}}
	>
		<span style={{ fontSize: '18px', fontWeight: 600 }}>{label}</span>
		<span style={{ fontSize: '24px', fontWeight: 700 }}>{value}</span>
	</div>
);

export default NumberFrame;
